export enum Pronouns {
  SHE_HER = 'She/Her',
  HE_HIM = 'He/Him',
  THEY_THEM = 'They/Them',
}

export default Pronouns;
